import { render } from "./NotesForm.vue?vue&type=template&id=335cf377"
import script from "./NotesForm.vue?vue&type=script&lang=js"
export * from "./NotesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__